$(document).ready(function () {
      setTimeout(function() {
            $('.oke-sr-total-text').text(function(index, text) {
                return text.replace(/ Reviews?/g,'');
            });
    }, 700);
  $(".custom_input_change").click(function () {
    const selectedAlt = $(this).attr("imagealt");
    $(".slider-for-variant, .slider-nav-variant, .desktop-slider-nav-variant .slick-slide").each(function () {
      var imagePath = $(this).find(".thumbnail-img").attr("alt");
      if (imagePath === selectedAlt) {
        var slideIndex = $(this).attr("data-slick-index");
        $(".slider-for-variant,.slider-nav-variant, .desktop-slider-nav-variant.slick-slider").slick("slickGoTo", slideIndex);
      }
    });
  });
setTimeout(function(){
            $(".rc-radio__label").first().hide();
            var labelText = $(".rc-radio__label").first().text();
            var price = labelText.split(" ").pop();
            var newHTML = labelText.replace(price, '');
            var spanElement = $("<span class='bundlePrice'>" + newHTML + "</span>");
             var spanElementPrice = $("<span class='bundlePriceVal'>" + price + "</span>");
            $(".rc-radio__label").first().after(spanElement);
             $(".bundlePrice").after(spanElementPrice);


},1000)
$(document).on('click', '.custom_input_change', function(){
      var labelText = $(this).attr('labelPriceCount');
            var price = labelText.split(" ").pop();
             $(".bundlePriceVal").text(price);
})
})
